export default __webpack_public_path__ + "static/media/mongodb-logo.21b2e078.svg";